var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBancroftIconsDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.1 35.2",
    style: {
      enableBackground: "new 0 0 28.1 35.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left_column"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left_column_00000070840281503418326140000000270100320446180031_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,0c0.5,0,1,0.1,1.6,0.4c0.6,0.3,1,0.5,1.4,0.9l8,8c0.3,0.3,0.6,0.8,0.9,1.4c0.2,0.6,0.4,1.1,0.4,1.6v21.1 c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.3-0.8,0.5-1.2,0.5H1.8c-0.5,0-0.9-0.2-1.3-0.5C0.2,34.3,0,33.9,0,33.4V1.7c0-0.5,0.2-0.9,0.5-1.2 C0.9,0.2,1.3,0,1.8,0H15.8L15.8,0z M24.6,15.8H14.1c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.3V3.5H3.5v28.1h21.1V15.8z  M6.1,18.9H22v2.6H6.1V18.9z M6.1,25H22v2.7H6.1V25z M24.6,12.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.1-0.2-0.1-0.3l-8-8 c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1v8.8H24.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancroftIconsDocument);
export default __webpack_public_path__ + "static/media/bancroft_icons-document.01456f5ac6510d4f12c903ebb4825e49.svg";
export { ForwardRef as ReactComponent };